import { render, staticRenderFns } from "./ModalTableLto539.vue?vue&type=template&id=63e1b743&"
import script from "./ModalTableLto539.vue?vue&type=script&lang=js&"
export * from "./ModalTableLto539.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports